export default __webpack_public_path__ + "static/media/inactive-eye.c4f9e649.svg";